import * as React from 'react';
import { IFilterIconProps } from './types';
import { UsersTooltip } from '../../../UsersTooltip/UsersTooltip';
import { Logo } from '../../../Logo/components/Logo/Logo';

export function FilterIcon({
    direction,
    logo,
    name,
    users,
}: IFilterIconProps) {
    return (
        <>
            {users.length  && (!logo || !logo.icon) ?
                <UsersTooltip users={users} isSemiBig direction={direction} />
                : <Logo name={name} logo={logo} isChangeColorOnReset />
            }
        </>
    );
}
